var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27778 8.58824H15.7222M7.27778 13.0588H13.6111M17.8333 3C18.6732 3 19.4786 3.35326 20.0725 3.98205C20.6664 4.61085 21 5.46369 21 6.35294V15.2941C21 16.1834 20.6664 17.0362 20.0725 17.665C19.4786 18.2938 18.6732 18.6471 17.8333 18.6471H12.5556L7.27778 22V18.6471H5.16667C4.32681 18.6471 3.52136 18.2938 2.9275 17.665C2.33363 17.0362 2 16.1834 2 15.2941V6.35294C2 5.46369 2.33363 4.61085 2.9275 3.98205C3.52136 3.35326 4.32681 3 5.16667 3H17.8333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.93e7ba89f4cb0d4755dc2118d499fec6.svg";
export { ForwardRef as ReactComponent };